import { blob, bool, publicKey, seq, struct, u16, u64, u8, u128 } from "../../marshmallow";

export const CpmmConfigInfoLayout = struct([
  blob(8),
  u8("bump"),
  bool("disableCreatePool"),
  u16("index"),
  u64("tradeFeeRate"),
  u64("protocolFeeRate"),
  u64("fundFeeRate"),
  u64("createPoolFee"),

  publicKey("protocolOwner"),
  publicKey("fundOwner"),
  seq(u64(), 16),
]);

export const CpmmPoolInfoLayout = struct([
  blob(8),

  publicKey("configId"),
  publicKey("poolCreator"),
  publicKey("vaultA"),
  publicKey("vaultB"),

  publicKey("mintLp"),
  publicKey("mintA"),
  publicKey("mintB"),

  publicKey("mintProgramA"),
  publicKey("mintProgramB"),

  publicKey("observationId"),

  u8("bump"),
  u8("status"),

  u8("lpDecimals"),
  u8("mintDecimalA"),
  u8("mintDecimalB"),

  u64("lpAmount"),

  // Added for snapper pool state
  u64("swapFeesToken0"),
  u64("swapFeesToken1"),
  u64("creatorFeesToken0"),
  u64("creatorFeesToken1"),
  //////////////////////////////

  u64("protocolFeesMintA"),
  u64("protocolFeesMintB"),

  // Removed for snapper pool state
  // u64("fundFeesMintA"),
  // u64("fundFeesMintB"),

  u64("openTime"),

  seq(u64(), 32),
]);
